import React, { useEffect, useRef, useState } from "react";
import { INTRO_VIDEO } from "../mock";

// Durata massima dell'intro: la fermiamo prima della fine (che sul video e' nera)
const MAX_DURATION_MS = 4500;

const IntroSplash = () => {
  const [show, setShow] = useState(() => {
    try {
      return sessionStorage.getItem("introPlayed") !== "1";
    } catch {
      return true;
    }
  });
  const [fading, setFading] = useState(false);
  const videoRef = useRef(null);
  const finishedRef = useRef(false);
  const timerRef = useRef(null);

  const finish = () => {
    if (finishedRef.current) return;
    finishedRef.current = true;
    if (timerRef.current) clearTimeout(timerRef.current);
    const v = videoRef.current;
    if (v) {
      try {
        v.pause();
      } catch {}
    }
    setFading(true);
    try {
      sessionStorage.setItem("introPlayed", "1");
    } catch {}
    setTimeout(() => setShow(false), 600);
  };

  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = "hidden";
    const v = videoRef.current;
    if (v) {
      v.muted = true;
      const p = v.play();
      if (p && typeof p.catch === "function") {
        p.catch(() => finish());
      }
    }
    // Hard cap on the intro length
    timerRef.current = setTimeout(finish, MAX_DURATION_MS);
    return () => {
      document.body.style.overflow = "";
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] bg-white flex items-center justify-center transition-opacity duration-500 ease-in-out ${
        fading ? "opacity-0" : "opacity-100"
      }`}
    >
      <video
        ref={videoRef}
        src={INTRO_VIDEO}
        className={`w-full h-full object-contain transition-opacity duration-200 ${
          fading ? "opacity-0" : "opacity-100"
        }`}
        autoPlay
        muted
        playsInline
        preload="auto"
        onEnded={finish}
      />

      {!fading && (
        <button
          onClick={finish}
          className="absolute bottom-6 right-6 text-xs tracking-[0.3em] uppercase text-gray-500 hover:text-black transition-colors"
        >
          Salta
        </button>
      )}
    </div>
  );
};

export default IntroSplash;
